export default __webpack_public_path__ + "static/iconFlor3-ad7defbea67cd4d82ad22c3d2b160cc0.png";